import { render, staticRenderFns } from "./PetitionDetails.vue?vue&type=template&id=64d8cb6c&scoped=true&"
import script from "./PetitionDetails.vue?vue&type=script&lang=js&"
export * from "./PetitionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PetitionDetails.vue?vue&type=style&index=0&id=64d8cb6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8cb6c",
  null
  
)

export default component.exports